export default __webpack_public_path__ + "static/media/MonitorPlay.b9b72439.svg";